import { PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import dayjs from 'dayjs';

import { useTranslateFn } from '@shared/Translate';
import type { UefatvEditorialContent } from '@shared-types/uefatv.types';
import { AccessLevel, MediaType } from '@shared-types/uefatv.types';

import * as styles from './styles.module.scss';

interface IconPlayWrapperProps {
  item: UefatvEditorialContent;
  grouped?: boolean;
}

export const VideoIcon = ({ item, grouped = false }: IconPlayWrapperProps) => {
  const t = useTranslateFn();

  return (
    <div
      className={clsx({
        [styles.iconPlayWrapper]: true,
        [styles.grouped]: grouped,
      })}
    >
      {!!item?.duration && (
        <span className={styles.duration}>{dayjs.duration(item.duration, 's').format('mm:ss')}</span>
      )}
      {!!item?.vodCount && (
        <span className={styles.vodcount}>
          {item.accessLevel !== AccessLevel.GRANTED.toString() && (
            <PkIcon name='support-lock-closed-filled' className={styles.accessDenied} color='ui-05' size='16' />
          )}
          {`${item.vodCount} ${item.vodCount === 1 ? t('video') : t('videos')}`}
        </span>
      )}
      {!!item.accessLevel && item.type === MediaType.VOD && (
        <div className={styles.iconPlay}>
          <PkIcon
            name={item.accessLevel === AccessLevel.GRANTED ? 'av-play' : 'support-lock-closed'}
            color='ui-05'
            size={grouped ? 16 : 24}
          />
        </div>
      )}
    </div>
  );
};
